import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAdminAuth } from './use-admin-auth';

/**
 * Redirects unauthenticated visitors to /login.
 * Renders children once Privy is ready and the user has a wallet address.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { ready, authenticated, account } = useAdminAuth();
  const location = useLocation();
  if (!ready) return null;
  if (!authenticated || !account) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
